<template>
  <!-- 弹窗 -->
  <a-modal
    :cancel-text="a_modal.cancelText"
    :ok-text="a_modal.okText"
    :title="a_modal.title"
    v-model:open="a_modal.visible"
    @ok="a_modal.handleOk"
  >
    {{ a_modal.content }}
  </a-modal>

  <div class="signature">
    <div class="actionsWrap">
      <div class="actions">
        <a-button type="primary" danger @click="back">返回</a-button>
        <a-button type="primary" @click="clear">清理</a-button>
        <a-button type="primary" @click="undo">撤销</a-button>
        <a-button type="primary" @click="redo">重做</a-button>
        <a-button type="primary" @click="submit">提交</a-button>
      </div>
    </div>
    <canvas id="canvas" class="canvas" />
  </div>
</template>

<script setup>
import axios from 'axios'
import SmoothSignature from 'smooth-signature'
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const role = ref(null)
const uuid = ref(null)
const a_modal = ref({
  cancelText: '取消', 
  content: '', 
  handleOk: null, 
  okText: '确定', 
  title: '', 
  visible: false, 
})
const signature = ref(null)

const initSignture = () => {
  const canvas = document.getElementById('canvas');
  const options = {
    width: window.innerWidth,
    height: window.innerHeight,
    minWidth: 3,
    maxWidth: 10,
    bgColor: 'transparent'
  }
  signature.value = new SmoothSignature(canvas, options);
}
const back = () => {
  router.push(`/order/${uuid.value}`)
}
const clear = () => {
  signature.value.clear()
}
const undo = () => {
  signature.value.undo()
}
const redo = () => {
  signature.value.redo()
}
const submit = async() => {
  const isEmpty = signature.value.isEmpty()
  if (isEmpty) {
    a_modal.value.title = 'Tips:'
    a_modal.value.content = '不能提交空白签名！'
    a_modal.value.visible = true
    a_modal.value.handleOk = () => {
      a_modal.value.visible = false
    }
    return
  }
  const canvas = signature.value.getRotateCanvas(-90)
  canvas.toBlob(async(blob) => {
    const result = await uploadBlob(blob)
    if (result.data.code != 200) {
      a_modal.value.title = 'Tips:'
      a_modal.value.content = '签名提交失败，请联系客服！'
      a_modal.value.visible = true
      a_modal.value.handleOk = () => {
        a_modal.value.visible = false
      }
      return
    } else {
      router.push(`/success/${uuid.value}`)
    }
  }, 'image/png')
}

function uploadBlob(blob) {
  const formData = new FormData()
  formData.append('uuid', uuid.value)
  formData.append('type', role.value)
  formData.append('file', blob, 'signature.png')
  return axios.post('https://api.gdpinganxing.com/api/upload/image', formData)
}

onMounted(() => {
  role.value = route.params.role
  uuid.value = route.params.id
  initSignture()
})
</script>

<style>
.signature {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.actionsWrap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 100%;
}
.actions {
  white-space: nowrap;
  transform: rotate(90deg);
}
.actions > button {
  margin-right: 8px;
  margin-left: 8px;
}
.canvas {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 52px;
  width: 100%;
  height: 100%;
}
</style>